/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Storage_AddonInputs */



/**
* | output |
* | --- |
* | "Storage add-on" |
*
* @param {Partner_Dashboard_Detail_Storage_AddonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_storage_addon = /** @type {((inputs?: Partner_Dashboard_Detail_Storage_AddonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Storage_AddonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicher-Add-on")
	return /** @type {LocalizedString} */ ("Storage add-on")
});